import arkButtons from './arkButtons'
import arkDwellTimeSku from './arkDwellTimeSku'
import arkNoInteractionsSku from './arkNoInteractionsSku'
import arkProductDetails from './arkProductDetails'
import arkSessionsSku from './arkSessionsSku'
import arkStoresTop from './arkTopStores'

const arkReducers = [arkButtons, arkDwellTimeSku, arkNoInteractionsSku, arkProductDetails, arkSessionsSku, arkStoresTop]

export default arkReducers
